export default __webpack_public_path__ + "static/media/digitaldoctor.8896900d.png";